import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import Input from '@taglivros/oef_componentes/build/components/input'

import { object } from 'prop-types'
import { useGlobal } from '../../contexts/GlobalContext'
import { navigateParaAdaComRedirect } from '../../utils/rotas/navigate'
import {
  BOTAO_CONFIRMAR,
  BOTAO_VOLTAR,
  DESCRICAO_ESQUECI_SENHA,
  EMAIL_INVALIDO,
  LABEL_CAMPO_EMAIL,
  SUCESSO_ESQUECI_SENHA,
  TITULO_ESQUECI_SENHA,
} from './constantsEsqueciMinhaSenha'
import { validaEmailOuCPF } from '../../utils/validadores/validadores'
import { empty, isEmptyObject } from '../../utils/helpers/helpers'
import { REQUIRED_MESSAGE, URLS } from '../../constants'
import { useAssociado } from '../../contexts/AssociadoContext'
import ModalErro from '../../components/ModalErro/ModalErro'
import { RECAPTCHA_KEY } from '../../utils/recaptcha'

const WrapperEsqueciMinhaSenha = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - ${( { sucessoRequisicao } ) => sucessoRequisicao ? '135px' : '85px'});

  h1 {
    ${StyleGuide.boldFonte}
    font-size: 40px;
    margin-bottom: 20px;

    @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 50px;
    }
  }

  h1, p {
    text-align: center;

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      margin: 0 auto 20px;
      max-width: 280px;
    }
  }

  .wrapper_email {
    margin: 30px auto 0;
    max-width: 280px;
    text-align: center;
    width: 100%;

    .form__row {
      margin-bottom: 25px;
    }

    @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
      max-width: 450px;
    }
  }

  a {
    color: ${StyleGuide.cores.branco};
    margin-top: 30px;
    margin-right: 30px;
    z-index: 0;
  }

  .wrapper_email a, button {
    margin-top: 20px;
  }
`

const MensagemSucesso = styled.p`
  && {
    background: ${StyleGuide.cores.verdeSucessoBackground};
    border-radius: 8px;
    color: ${StyleGuide.cores.cinza600};
    font-size: 14px;
    line-height: 1.45;
    margin: 0 0 25px;
    max-width: 100%;
    padding: 12px 14px;
    text-align: left;
  }
`

const CaptchaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 4px;
  cursor: pointer;
  margin: 20px;
  align-items: center;
`

const EsqueciMinhaSenha = ( { location } ) => {
  const { erroEsqueciSenha, isAssociadoLogado, setErroEsqueciSenha } = useGlobal()
  const { postEsqueciSenhaNaoLogado, sucessoEsqueciMinhaSenha } = useAssociado()
  const [ valueInput, setValueInput ] = useState( {} )
  const [ erros, setErros ] = useState( {} )
  const [ sucessos, setSucessos ] = useState( {} )
  const [ botaoHabilitado, setBotaoHabilitado ] = useState( false )
  const { captcha, setCaptcha } = useGlobal()
  const redirectTo = new URLSearchParams( location.search ).get( 'redirectTo' )
  const rotaVoltarLogin = redirectTo
    ? `${URLS.LOGIN}?redirectTo=${encodeURIComponent( redirectTo )}`
    : URLS.LOGIN

  if ( isAssociadoLogado ) {
    navigateParaAdaComRedirect( redirectTo )
    return null
  }

  useEffect( () => {
    if ( sucessos.email ) {
      setBotaoHabilitado( true )
    } else if ( erros.email ) {
      setBotaoHabilitado( false )
    }
  }, [ sucessos ] )

  useEffect( () => {
    const checkRecaptcha = () => {
      if ( window.grecaptcha && window.grecaptcha.enterprise && window.grecaptcha.enterprise.render ) {
        renderRecaptcha()
      } else {
        setTimeout( checkRecaptcha, 100 )
      }
    }
    checkRecaptcha()
  }, [] )

  const sanitizeEmail = ( email ) => {
    return email.trim()
  }

  const validador = event => {
    const { name, value } = event.target

    const sanitizedEmail = sanitizeEmail( value )

    let validacaoErros = {}

    if ( sanitizedEmail === '' ) {
      validacaoErros = {
        ...erros,
        [ name ]: REQUIRED_MESSAGE
      }
    } else if ( validaEmailOuCPF( sanitizedEmail ) ) {
      validacaoErros = {
        ...erros,
        [ name ]: validaEmailOuCPF( sanitizedEmail )
      }
    }

    setSucessos( {
      ...sucessos,
      [ name ]: empty( validacaoErros[ name ] )
    } )

    setErros( validacaoErros )

    setValueInput( {
      ...valueInput,
      [ name ]: sanitizedEmail
    } )
  }

  const handleSubmit = () => {
    if ( !isEmptyObject( valueInput ) && valueInput.email ) {
      postEsqueciSenhaNaoLogado( valueInput.email.toLowerCase(), redirectTo )
    }
  }

  function renderRecaptcha() {
    try {
      const { grecaptcha } = window
      if ( !RECAPTCHA_KEY || RECAPTCHA_KEY === 'undefined' ) {
        console.error( 'RECAPTCHA_KEY não está configurada' )
        return
      }
      const captchaElement = document.getElementById( 'divCaptcha' )
      if ( !captchaElement ) {
        console.error( 'Elemento divCaptcha não encontrado' )
        return
      }
      grecaptcha.enterprise.render( 'divCaptcha', {
        'sitekey': `${RECAPTCHA_KEY}`,
        'callback': callbackRecaptcha,
      } )
    } catch ( error ) {
      console.error( 'Erro ao renderizar reCAPTCHA:', error )
    }
  }

  function callbackRecaptcha( captchaToken ) {
    setCaptcha( captchaToken )
  }

  return (
    <WrapperEsqueciMinhaSenha
      sucessoRequisicao={ sucessoEsqueciMinhaSenha }
    >
      { erroEsqueciSenha && !isEmptyObject( erroEsqueciSenha ) ?
        <ModalErro
          descricao={ EMAIL_INVALIDO.descricao }
          showModal={ !isEmptyObject( erroEsqueciSenha ) }
          titulo={ EMAIL_INVALIDO.titulo }
          toggleModal={ () => setErroEsqueciSenha( null ) }
        /> : null}

      <h1>{ TITULO_ESQUECI_SENHA }</h1>

      <p>{ DESCRICAO_ESQUECI_SENHA }</p>

      <div
        className="wrapper_email"
      >
        <Input
          erro={ erros.email }
          label={ LABEL_CAMPO_EMAIL }
          name="email"
          onChange={ validador }
          sucesso={ sucessos.email }
          testId="input-email"
          value={ valueInput.email }
        />

        { sucessoEsqueciMinhaSenha ? (
          <MensagemSucesso
            aria-live="polite"
            data-testid="mensagem-sucesso-esqueci-senha"
            role="status"
          >
            { SUCESSO_ESQUECI_SENHA }
          </MensagemSucesso>
        ) : null }

        <CaptchaContainer>
          <div
            className="g-recaptcha"
            data-action="CHECKOUT"
            data-sitekey={ RECAPTCHA_KEY }
            id="divCaptcha"
          />
        </CaptchaContainer>

        <Button
          href={ rotaVoltarLogin }
          target=""
          testId="botao-voltar-email-esqueci-senha"
        >
          { BOTAO_VOLTAR }
        </Button>

        <Button
          disabled={ !botaoHabilitado || captcha === null }
          onClick={ handleSubmit }
          testId="botao-enviar-email-esqueci-senha"
        >
          { BOTAO_CONFIRMAR }
        </Button>
      </div>
    </WrapperEsqueciMinhaSenha>
  )
}

EsqueciMinhaSenha.propTypes = {
  'location': object.isRequired
}

export default EsqueciMinhaSenha
